__turbopack_context__.v({
  "contentAnimation": "VPVY-W_contentAnimation",
  "fadeInUp": "VPVY-W_fadeInUp",
  "headingAnimation": "VPVY-W_headingAnimation",
  "sectionAnimation": "VPVY-W_sectionAnimation",
});
